/**
 * Height of the masquerade banner, in px.
 *
 * Single source of truth: the banner's CSS pins `minHeight` to this value and `QuoteSidebar` offsets
 * its sticky positioning by it. It used to be a bare number here that had to be kept in step with the
 * banner's padding by hand — so any restyle silently misaligned the quote sidebar for masquerading
 * users. Change this and both move together.
 */
export const MASQUERADE_BANNER_HEIGHT = 44

export interface HeaderHeightOptions {
  isMasquerading?: boolean
  isCorporate?: boolean
  isTrial?: boolean
  isSticky?: boolean
  isTemplate?: boolean
}

/**
 * Calculate the header height for sidebar positioning
 */
export function calculateHeaderHeight(options: HeaderHeightOptions = {}): number {
  const { isMasquerading, isTrial, isSticky, isTemplate } = options

  if (isSticky) {
    // When sticky header is active, only account for the sticky header height
    let stickyHeight = 82 // base sticky header height

    // Additional height for template headers (they have more content when sticky)
    if (isTemplate) {
      stickyHeight += 30 // extra height for template sticky headers
    }

    return stickyHeight
  }

  // When at top of page, account for all visible header elements
  let totalHeight = 0

  // Base header height
  const baseHeaderHeight = 50
  totalHeight += baseHeaderHeight

  // Trial banner height (when visible at top)
  if (isTrial) {
    totalHeight += 59 // trial banner height
  }

  // Masquerade banner height (when visible at top)
  if (isMasquerading) {
    totalHeight += MASQUERADE_BANNER_HEIGHT
  }

  return totalHeight
}

/**
 * Get the CSS value for top positioning considering header height
 */
export function getHeaderTopOffset(options: HeaderHeightOptions = {}): string {
  return `${calculateHeaderHeight(options)}px`
}
